// ----------------------------------------------------------------------
// <copyright file="Izenda.SecurityPoliciesDetail.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function () {
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var action = require('./Izenda.SecurityPoliciesDetailAction');
  var constants = require('logic/data/Izenda.SecurityPoliciesConstant');

  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var Panel = require('share/components/controls/Izenda.Panel');
  var Alert = require('share/components/controls/Izenda.Alert');
  var MainContent = require('share/components/layout/Izenda.MainContent');
  var Input = require('share/components/controls/Izenda.Input');

  var ActionBar = require('./ActionBar/Izenda.ActionBar');
  var ScrollBox = require('share/components/controls/Izenda.ScrollBox');
  var PasswordPolicies = require('./PasswordPolicies/Izenda.PasswordPolicies');
  var AccountLockoutPolicies = require('./AccountLockoutPolicies/Izenda.AccountLockoutPolicies');
  var UserPolicies = require('./UserPolicies/Izenda.UserPolicies');

  var SecurityPoliciesDetail = React.createClass({

    componentDidMount: function() {
      var props = this.props;
      var loader = props.loader;
      var store = props.store;

      loader.startLoading();
      store.init();
      store.loadSecurityPoliciesDetail()
           .finally(loader.endLoading.bind(loader));
    },

    render: function () {
      var props = this.props;
      var store = props.store;

      return (
        <div className='izenda-SecurityPoliciesDetail u_fullHeight u-posRelative'>
          <ActionBar store={store} onSave={props.onSave} onCancel={props.onCancel} />
          <div className='u_fullHeight izenda-SecurityPoliciesPanel'>
            <ScrollBox>
              <div className='izenda-ControlPanel'>
                <PasswordPolicies       store={store} />
                <AccountLockoutPolicies store={store} />
                <UserPolicies store={store} />
              </div>
            </ScrollBox>
          </div>
        </div>
      );
    }


  });

  module.exports = connect(action)(SecurityPoliciesDetail);
}());



// WEBPACK FOOTER //
// ./ui/modules/Settings/SystemConfiguration/SecurityPolicies/Izenda.SecurityPoliciesDetail.jsx